function productHasNoBF() {
  const tagsInput = document.querySelector('input[name="product-tags"]');
  if (!tagsInput) return false;

  const tags = tagsInput.value.toLowerCase();
  return tags.includes('no_bfcm_discount');
}


/* ============================================================
   GLOBAL TIERED DISCOUNT SYSTEM
   ============================================================ */

jQuery(function($){

  /* ----------------------------
     Defaults for Nomadica cans
     (NO changing subscription/one-time here to respect Recharge)
     ---------------------------- */
  function setNomadicaDefaultState() {
    const packSelect = $('select[name="options[Pack Size]"], select[name="options[Size]"]');

    if (packSelect.find('option[value="4 cans = 1.3 bottles"]').length) {
      // Default to the 4-can option
      packSelect.val("4 cans = 1.3 bottles").trigger("change");

      // Default quantity = 4
      $('.product__quantity, [data-js-product-quantity]').val(4).trigger('change');
    }
  }

  /* ----------------------------
     Helpers for Recharge shadowRoot
     ---------------------------- */
  function isOneTimeSelected() {
    const host = document.querySelector('recharge-subscription-widget');
    if (!host || !host.shadowRoot) return true; // treat as one-time if no widget

    const onetime = host.shadowRoot.querySelector('input[value="onetime"]');
    if (!onetime) return true;

    return onetime.checked;
  }

  function clickShadowRootInput(selector) {
    const host = document.querySelector('recharge-subscription-widget');
    if (!host || !host.shadowRoot) return;

    const el = host.shadowRoot.querySelector(selector);
    if (el) el.click();
  }

  /* ----------------------------
     Tier logic
     ---------------------------- */
  function getTierDiscount(subtotal) {
    if (subtotal >= 200) return 0.35;
    if (subtotal >= 100) return 0.30;
    return 0.25;
  }

  /* ----------------------------
     Update one-time row inside Recharge widget
     ---------------------------- */
  function updateOneTimeShadowPrice(discountedUnit, originalUnit) {
    const host = document.querySelector('recharge-subscription-widget');
    if (!host || !host.shadowRoot) return;

    const otpPriceEl = host.shadowRoot.querySelector('.rc-selection__onetime .rc-price');
    if (!otpPriceEl) return;

    // Official pattern you want:
    // <span class="rc-price"><strong>$X</strong> <s>$Y</s></span>
    otpPriceEl.innerHTML = `<strong>$${discountedUnit}</strong> <s>$${originalUnit}</s>`;
  }

  /* ----------------------------
     Core pricing + messaging logic
     ---------------------------- */
  function updateTieredPricing() {
    const qty   = Number($('[data-js-product-quantity]').val()) || 1;
    const price = Number($('input[name="singleprice"]').val());
    if (!price) return;

    const baseSubtotal = price * qty;
    const oneTime      = isOneTimeSelected();
    const noBF         = productHasNoBF();

    /* ============================================================
       CASE 1: PRODUCT BLOCKED FROM BFCM DISCOUNTS
       ============================================================ */
    if (noBF) {
      // No tiered discount, no subscription discount.

      $('[data-js-product-add-to-cart-text]').html(
        `Add to Cart - $${baseSubtotal.toFixed(2)}`
      );

      $('#ff-new-per-bottle-price').html(
        `Equivalent to $${price.toFixed(2)} / unit`
      );

      $('.tier_discount').hide();

      // Reset shadowRoot one-time price to clean default
      const host = document.querySelector('recharge-subscription-widget');
      if (host && host.shadowRoot) {
        const otpEl = host.shadowRoot.querySelector('.rc-selection__onetime .rc-price');
        if (otpEl) {
          otpEl.textContent = `$${price.toFixed(2)}`;
        }
      }

      return; // STOP. No discount logic allowed.
    }

    /* ============================================================
       CASE 2: NORMAL PRICING LOGIC
       ============================================================ */

    /* ------------------------------
       SUBSCRIPTION (20% OFF ALWAYS)
       ------------------------------ */
    if (!oneTime) {
      const subDiscount  = 0.20;
      const subSubtotal  = (baseSubtotal * (1 - subDiscount)).toFixed(2);
      const subUnit      = (price * (1 - subDiscount)).toFixed(2);

      $('[data-js-product-add-to-cart-text]').html(
        `Add to Cart - $${subSubtotal} <s>$${baseSubtotal.toFixed(2)}</s>`
      );

      $('#ff-new-per-bottle-price').html(
        `Equivalent to $${subUnit} / unit`
      );

      $('.tier_discount').hide();

      const tier         = getTierDiscount(baseSubtotal);
      const otpUnitPrice = (price * (1 - tier)).toFixed(2);
      updateOneTimeShadowPrice(otpUnitPrice, price.toFixed(2));

      return;
    }

    /* --------------------------------
       ONE-TIME (TIERED DISCOUNTS)
       -------------------------------- */
    const tier            = getTierDiscount(baseSubtotal);
    const finalSubtotal   = (baseSubtotal * (1 - tier)).toFixed(2);
    const discountedUnit  = (price * (1 - tier)).toFixed(2);

    let saveMsg = "";
    if (tier === 0.25) saveMsg = "You're saving 25% today!";
    if (tier === 0.30) saveMsg = "You're saving 30% today!";
    if (tier === 0.35) saveMsg = "You're saving 35% today!";

    let nextMsg = "";
    if (tier === 0.25 && baseSubtotal < 100) {
      nextMsg = `Spend $${(100 - baseSubtotal).toFixed(2)} more to reach 30% off!`;
    } else if (tier === 0.30 && baseSubtotal < 200) {
      nextMsg = `Spend $${(200 - baseSubtotal).toFixed(2)} more to reach 35% off!`;
    }

    $('.tier_discount').show().html(`<h4>${saveMsg}</h4>${nextMsg}`);

    $('[data-js-product-add-to-cart-text]').html(
      `Add to Cart - $${finalSubtotal} <s>$${baseSubtotal.toFixed(2)}</s>`
    );

    $('#ff-new-per-bottle-price').html(
      `Equivalent to $${discountedUnit} / unit`
    );

    updateOneTimeShadowPrice(discountedUnit, price.toFixed(2));
  }


  // Expose for ProductQuantity component
  window.updateTieredPricing = updateTieredPricing;

  /* ----------------------------
     SHADOWROOT LISTENER ATTACHMENT
     ---------------------------- */
  function attachRechargeListeners() {
    const host = document.querySelector('recharge-subscription-widget');
    if (!host || !host.shadowRoot) return;

    const radios = host.shadowRoot.querySelectorAll('.rc-purchase-option__input');

    radios.forEach((radio) => {
      radio.removeEventListener('change', updateTieredPricing);
      radio.addEventListener('change', updateTieredPricing);
    });
  }

  /* ----------------------------
     Track product changes (qty, variant, pack size, etc.)
     ---------------------------- */
  $(document).on(
    'change',
    '[data-js-product-quantity], select[name="id"], select[name="options[Pack Size]"], select[name="options[Size]"]',
    updateTieredPricing
  );

  /* ----------------------------
     Recharge events + Observer
     ---------------------------- */
  const rechargeHost = document.querySelector('recharge-subscription-widget');

  if (rechargeHost) {
    // Recharge custom events
    rechargeHost.addEventListener('rc:option-changed', updateTieredPricing);
    rechargeHost.addEventListener('rc-widget:changed', updateTieredPricing);

    // Watch for Recharge re-renders (Lit updates)
    const observer = new MutationObserver(() => {
      attachRechargeListeners();
      updateTieredPricing();
    });

    observer.observe(rechargeHost, { childList: true, subtree: true });

    // Initial attach (in case it's already rendered)
    setTimeout(attachRechargeListeners, 500);
  }

  /* ----------------------------
     Initial load
     ---------------------------- */
  setNomadicaDefaultState();
  setTimeout(() => {
    attachRechargeListeners();
    updateTieredPricing();
  }, 300);

});
